export const SEGMENT_KEY_PLACEHOLDER = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX';
export const LMS_GTM_ID_PLACEHOLDER = 'GTM-XXXXXXX';
export const LMS_GA_ID_PLACEHOLDER = 'G-XXXXXXXXXX';
export const WP_GA_ID_PLACEHOLDER = 'G-XXXXXXXXXX';
export const WP_GTM_ID_PLACEHOLDER = 'GTM-XXXXXXX';
